export type Volume = {
  number: string
  title: string
  promise: string
  /** Banda del encabezado en la sección de tomos (fondo claro). */
  badge: string
  /** Banda de la portada dibujada (fondo navy). */
  accent: string
  contents: string[]
}

/** Los 6 tomos reales del pack (Índices DPS-33, aprobados 2026-10-09). */
export const volumes: Volume[] = [
  {
    number: '01',
    title: 'Season-Ready Foundations',
    promise:
      'Start the season with a system, not nerves — the 4-Block engine and your first six practices, already built.',
    badge: 'bg-navy',
    accent: 'bg-gold',
    contents: [
      'The 4-Block Practice System in 45, 60 and 90-minute versions',
      'The First-15 Routine that settles any practice',
      'The Energy Rule, so nobody stands around bored',
      'Your first six practices, ready to run',
      'Plans for a late field, one coach with 14 players, and rainy days',
    ],
  },
  {
    number: '02',
    title: 'Defense That Holds',
    promise:
      'An infield and an outfield that stop giving away free bases.',
    badge: 'bg-clay',
    accent: 'bg-clay',
    contents: [
      'The Ready-Field-Throw Cycle behind every defensive play',
      'The Funnel: ball to body to throw in one motion',
      'The Line Rule: where each outfielder throws, every time',
      'Double plays, tag plays and first-base footwork',
      'Infield, outfield and combined practices, ready to run',
    ],
  },
  {
    number: '03',
    title: 'Bats That Produce',
    promise:
      'Everyone makes contact — and the lineup starts driving in runs.',
    badge: 'bg-green',
    accent: 'bg-green',
    contents: [
      'The Load-Launch-Finish swing model',
      'The Three-Round Cage: rounds with a goal, not just swings',
      'The Count Plan: what to look for ahead or behind',
      'Bunting and slap hitting, step by step',
      'Rotating cage practices for the whole team',
    ],
  },
  {
    number: '04',
    title: 'Smart on the Bases',
    promise: 'Run the bases to win bases — not just to run.',
    badge: 'bg-clay-deep',
    accent: 'bg-gold',
    contents: [
      'The Green-Light System: when she decides, when she looks at you',
      'The Read-Step that decides steal or stay',
      'A sliding progression taught safely',
      'Tag-ups, first-and-third and situational running',
      'The Two-Base Mindset from the moment of contact',
    ],
  },
  {
    number: '05',
    title: 'Shut Down the Inning',
    promise:
      'Catchers, pitchers and the team plays that close out an inning.',
    badge: 'bg-green-deep',
    accent: 'bg-clay',
    contents: [
      'The Receiver’s Base: framing, blocking and throwdowns',
      'The Bullpen Block: pitchers inside team practice',
      'Pitch counts and rest, handled with care',
      'The Cutoff Map: who cuts and where the ball goes',
      'Bunt coverage, rundowns and pop-up priority',
    ],
  },
  {
    number: '06',
    title: 'Game Day, Handled',
    promise:
      'From the season plan to game day — every call decided ahead of time.',
    badge: 'bg-navy-mid',
    accent: 'bg-green',
    contents: [
      'The Game-Day Timeline from arrival to first pitch',
      'A 45-minute pregame routine, ready to run',
      'The Playing-Time Plan that heads off parent conflicts',
      'Scripts for the tough conversations with parents',
      'The Season Arc: preseason to playoffs, week by week',
    ],
  },
]
